import { PasswordInput } from '@/presentation/components/password'
import type { AutoFormWidgetsProps } from '../autoForm'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

export function PasswordWidget(props: AutoFormWidgetsProps) {
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>{props.options?.label as string}</FieldLabel>
      <FieldControl>
        <PasswordInput
          className="bg-white"
          placeholder={props.options?.placeholder as string | undefined}
          defaultValue={props.initialValue}
        />
      </FieldControl>
      <FieldMessage />
    </Field>
  )
}
